import React, { forwardRef } from 'react'

import { IconProps } from './types'

const ArrayIcon = forwardRef<SVGSVGElement, IconProps>(
  ({ size, stroke, ...props }, ref) => (
    <svg
      ref={ref}
      width={props.width ?? size}
      height={props.height ?? size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5 3.5H3V12.5H5M11 3.5H13V12.5H11M10.5 7.875H10.25V8.125H10.5V7.875ZM8.125 7.875H7.875V8.125H8.125V7.875ZM5.75 7.875H5.5V8.125H5.75V7.875Z"
        stroke={stroke || 'currentColor'}
      />
    </svg>
  ),
)
ArrayIcon.displayName = 'ArrayIcon'

export default ArrayIcon
